import { useState, createContext, useRef, useContext } from "react";
import "./App.css";
import { AuthContext } from "./login/AuthProvider";
import PlanoTipo from "./components/PlanoTipo";
import LoginPrompt from "./login/LoginPrompt";

export const AppContext = createContext();

function App() {
  //#region VARS --------------------------------------------------------
  const { manager, user, setUser, setIsAuthenticated } =
    useContext(AuthContext);

  const clientId = manager.clientId;

  const [userData, setUserData] = useState();
  const showLogs = useRef(false);
  //#endregion VARS -----------------------------------------------------

  const toggleConsoleLogs = () => {
    showLogs.current = !showLogs.current;
  };

  const handleLogout = () => {
    localStorage.removeItem("w_wkt");
    localStorage.removeItem("g_wkt");
    localStorage.removeItem("ms_wkt");
    // localStorage.clear();
    setIsAuthenticated(false);
    setUser(null);
    // setShowConfirmLogout(false);
  };

  return (
    <AppContext.Provider
      value={{
        clientId,
        userData,
        setUserData,
        showLogs,
      }}
    >
      <div className="App">
        <div className="background">
          <img src="/imgs/fondo-proyectos.svg" alt="" />
        </div>
        <div className="navBar">
          <div /*DEBUG BTN*/ className="debug">
            <button onClick={toggleConsoleLogs}>Debugging</button>
          </div>
          <div className="clientLogo flex-center">
            <img src="imgs/logo-bolivar_scroll.svg" alt="navBar-Logo" />
          </div>
          <span className="navBar-Greeting">
            {user !== null
              ? `Hola ${user.userNames},\nBienvenido a Plano Tipo.`
              : "Bienvenido a Plano Tipo."}
          </span>
          {user && manager.enableAuthSystem && (
            <div className="signout flex-center">
              <button
                id="g_id_signout"
                className="flex-center"
                onClick={handleLogout}
              >
                <span className="login-capital">
                  {user.userNames
                    ?.split(" ")
                    .slice(0, 2)
                    .map((word) => word.charAt(0))
                    .join("")}
                </span>
                Cerrar Sesión
              </button>
            </div>
          )}
        </div>
        <div id="homeContainer" className="flex-center">
          {!user && (
            <div className="home-hero">
              <img
                className="homeContainer-Logo"
                src="/imgs/LogoCliente.png"
                alt="Logo Constructora Bolívar"
              />
              <div className="divider" />
              <div className="homeContainer-description">
                <p style={{ fontSize: "16px", padding: 0 }}>Aplicación Web</p>
                <h1>Plano Tipo</h1>
                <p style={{ fontSize: "16px", padding: 0 }}>
                  Herramienta para crear documentos <b>PDF</b> con los planos
                  ambientados de una unidad.
                </p>
              </div>
            </div>
          )}
          {!user && <LoginPrompt />}
        </div>
        {user && <PlanoTipo />}
        <div className="footer flex-center">
          <img
            className="footerIcon"
            src="imgs/FavIcon__Workobot_02.png"
            alt="Logo Workobot.com"
            style={{ height: "25px" }}
          />
          <span
            style={{
              textAlign: "right",
              fontSize: "12px",
              lineHeight: "12px",
              color: "white",
            }}
          >
            Desarrollado por{" "}
            <a
              href="https://www.workobot.com/"
              target={"_blank"}
              rel="noreferrer"
              style={{ color: "white" }}
            >
              Workobot.com
            </a>
          </span>
        </div>
      </div>
    </AppContext.Provider>
  );
}

export default App;
